import { TradeStatus } from '../enums';

export const TRADES_COUNT_TO_CALCULATE_SMART_RATING = 25;
export const TIME_HALF_LIFE_DAYS = 100;
export const TRADE_HALF_LIFE = 50;
export const TRADES_LOOKBACK_DAYS = 365;
export const MAX_TRADES_PER_USER = 500;
export const MIN_TRADES_FOR_MARKET_STATS = 3;
export const PERFORMANCE_LIMIT = 50;

export const TREND_PERIOD_DAYS = { weekly: 7, monthly: 30 } as const;

export const WIN_LOSS_SQL = `SUM(CASE WHEN trade.status = '${TradeStatus.Win}' THEN 1 ELSE 0 END)::int`;

let _playerMarketTypes: string[] | null = null;

export async function getPlayerMarketTypes(): Promise<string[]> {
	if (!_playerMarketTypes) {
		const { marketConfigMap } = await import('../configs/market.config');
		_playerMarketTypes = [
			...new Set(
				([] as string[])
					.concat(
						...Object.values(marketConfigMap).map((config) => (config ? Object.keys(config) : []))
					)
					.filter((key: string) => /Player/i.test(key))
			),
		];
	}
	return _playerMarketTypes;
}
